// Clients who remove linking for the text 'Account ending in XXXX' in card header
var CLIENTS_WITHOUT_LINKING = [
    "virgin",
    "jcrew",
    "cathay",
    "onepaywalmart",
    "ebaycb",
    "suncountry",
];
export default CLIENTS_WITHOUT_LINKING;
//# sourceMappingURL=clientsWithoutLinking.js.map